import * as React from "react";


export interface EditableLabelProps {
  value: string;
  onValueChange: (newValue: string) => void;
  allowNewline?: boolean;
  className?: string;
  style?: React.CSSProperties;
  width?: string;
}

export default class EditableLabel extends React.Component<EditableLabelProps> {
  cachedTextValue: string;
  spanRef: React.RefObject<HTMLSpanElement> = React.createRef();
  constructor(props: EditableLabelProps) {
    super(props);
    this.cachedTextValue = props.value;
  }
  componentDidUpdate(prevProps: EditableLabelProps) {
    if(this.props.value !== this.cachedTextValue) {
      this.spanRef.current!.innerText = this.props.value;
    }
  }
  componentDidMount() {
    this.spanRef.current!.innerText = this.cachedTextValue;
  }
  textEdited(newText: string) {
    if (newText != this.cachedTextValue) {
      this.props.onValueChange(newText);
      this.cachedTextValue = newText;
    }
  }
  render() {
    return (
      <span
        ref={this.spanRef}
        onInput={(e) => {
          const spanEl = (e.target as HTMLSpanElement);
          this.textEdited(spanEl.innerText.replace(/\r?\n|\r/, ''));
        }}
        onKeyPress={this.props.allowNewline ? (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        } : undefined}
        className={this.props.className}
        contentEditable={true}
        style={this.props.style}></span>
    );
  }
}
